import React, { useEffect, useState } from 'react';
import { PaymentMethodList, addPaymentMethod, editPaymentMethod, deletePaymentMethod, paymentMethodDetails, changePaymentTypeStatus, changePaymentMethodStatus } from '../../../services/payment-method.services';
import RecordNotFound from '../../../shared/recordNotFound';
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { LOADER_TIMEOUT_TIME, PAYMENT_METHOD_TYPES, SWAL_SETTINGS } from "../../../../../utils/Constants";
import { handleServerValidations } from "../../../../../utils/commonfunction";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import Skeleton from "react-loading-skeleton";
import { useFormik } from "formik";
import { Drawer } from "rsuite";
import * as Yup from 'yup';
import CustomError from '../../../../../utils/customError';

function PaymentMethod() {

  const [list, setList] = useState([]);

  const [addDrawer, setAddDrawer] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [paymentType, setPaymentType] = useState({});
  const [paymentMethodStatus, setPaymentMethodStatus] = useState(false);
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);


  useEffect(() => {
    setLoader(true);
    PaymentMethodList({ global_search: PAYMENT_METHOD_TYPES.CREDIT_CARD }).then((response) => {
      setTimeout(() => { setLoader(false) }, LOADER_TIMEOUT_TIME);
      setList(response.data.list);
      setPaymentMethodStatus(response?.data?.payment_acceptance?.credit_card_payments_acceptance);

    })
      .catch((err) => {
        setTimeout(() => { setLoader(false) }, LOADER_TIMEOUT_TIME);
        console.log(err)
      })
  }, [paymentType]);

  const formAddPaymentType = useFormik({
    initialValues: { payment_type: "" },
    validationSchema: Yup.object({
      payment_type: Yup.string()
        .trim()
        .required("restaurant.payment_method.payment_type_error")
        .test(
          "no-symbols",
          "Special characters are not allowed",
          value => {
            if (!value) return false;
            return /^[a-zA-Z0-9 ]+$/.test(value);
          }
        )

    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      setAddSubmissionLoader(true);
      const formData = new FormData();
      setPaymentType({ payment_type: values.payment_type });
      formData.append("payment_method_type", PAYMENT_METHOD_TYPES.CREDIT_CARD);
      formData.append("payment_type", values.payment_type);
      addPaymentMethod(formData)
        .then((response) => {
          setAddSubmissionLoader(false);
          if (response.success) {
            formAddPaymentType.resetForm();
            setAddDrawer(false);
            setPaymentType({});
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error updating payment method", error);
        });
    },
  });

  const formEditPaymentType = useFormik({
    initialValues: { payment_type: "", o_id: "" },
    validationSchema: Yup.object({
      payment_type: Yup.string()
        .trim()
        .required("restaurant.payment_method.payment_type_error")
        .test(
          "no-symbols",
          "Special characters are not allowed",
          value => {
            if (!value) return false;
            return /^[a-zA-Z0-9 ]+$/.test(value);
          }
        )
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("payment_method_type", PAYMENT_METHOD_TYPES.CREDIT_CARD);
      formData.append("payment_type", values.payment_type);
      formData.append("o_id", values.o_id);
      setEditSubmissionLoader(true);
      editPaymentMethod(formData)
        .then((response) => {
          setEditSubmissionLoader(false);
          if (response.success) {
            formEditPaymentType.resetForm();
            setEditDrawer(false);
            setPaymentType({});
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setEditSubmissionLoader(false);
          console.error("Error updating payment method", error);
        });
    },
  });

  const handlePaymentEdit = (o_id) => {
    paymentMethodDetails(o_id).then((response) => {
      setEditDrawer(true);
      formEditPaymentType.setFieldValue("payment_type", response?.data?.payment_type);
      formEditPaymentType.setFieldValue("o_id", response?.data?._id)

    }).catch((err) => { console.log(err) })
  };

  const handlePaymentDelete = (o_id) => {
    Swal.fire({
      title: t("restaurant.payment_method.msg_are_you_sure"),
      text: t("restaurant.payment_method.btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("restaurant.payment_method.btn_delete"),
      cancelButtonText: t("restaurant.payment_method.btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {

        deletePaymentMethod({ o_id: o_id })
          .then((response) => {
            if (response.success) {
              setPaymentType({});
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.error("Error deleting payment method", error);
            Swal.fire({
              icon: "error",
              text: "An error occurred while deleting the payment method.",
              ...SWAL_SETTINGS,
            });
          });
      } else {
        // Swal.fire({
        //   icon: "info",
        //   text: t("delete_cancelled"),
        //   ...SWAL_SETTINGS,
        // });
      }
    }).catch((error) => {
      console.error("Error handling deletion confirmation", error);
    });
  };

  const handleChangeStatus = (item) => {
    let dataForUpdate = {
      o_id: item._id,
      status: item.status === 1 ? 0 : 1
    }
    changePaymentTypeStatus(dataForUpdate).then((response) => {
      setPaymentType({});
      Swal.fire({
        icon: "success",
        text: response.message,
        ...SWAL_SETTINGS,
      });
    }).catch((err) => { console.log(err) })
  };

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">Payment Methods</h4>
        </div>
        <div className="payment-method-ui">
          <div className="card">
            <div className="card-body p-4">
              {loader ? (
                <div>
                  <Skeleton height={60} count={5} />
                </div>
              ) : (
                <>
                  <div className="d-flex justify-content-between">
                    <div>
                      <h3>{t("restaurant.payment_method.accept_credit_card_heading")}</h3>
                      <p>{t("restaurant.payment_method.accept_credit_card_text")}</p>
                    </div>
                    {/* <div className="form-check form-switch">
                      <input className="form-check-input cp" type="checkbox" checked={paymentMethodStatus} onChange={() => { handlePaymentMethodStatus() }} />
                    </div> */}
                  </div>
                  <hr className="mt-2"></hr>
                  <div className="payment-method-list mt-0">
                    {/* <h3> {t("restaurant.payment_method.payment_type_label")}</h3> */}
                    <div className="payment-method-row">
                      {list && list.length > 0 ? (
                        list.map((item, index) => (
                          <div className="payment-method-item d-flex align-items-center" key={index}>
                            <div className="form-check">
                              <input className="form-check-input cp" type="checkbox" id={`opening_check_${index}`} onChange={() => handleChangeStatus(item)} checked={item.status === 1} disabled={item.is_editable === false} />
                              <label className="form-check-label cp text-capitalize" htmlFor={`opening_check_${index}`}>
                                {item.payment_type}
                              </label>
                            </div>

                            <div className="payment-method-btns d-inline-flex gap-3 ms-auto">
                              <button className="btn btn-icon" disabled={item.is_editable === false} onClick={() => handlePaymentEdit(item._id)}>
                                <i className="ti ti-edit"></i>
                              </button>

                              <button className="btn btn-icon" disabled={item.is_editable === false} onClick={() => handlePaymentDelete(item._id)}>
                                <i className="ti ti-trash"></i>
                              </button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <RecordNotFound heading="restaurant.payment_method.no_record_found" />
                      )}
                    </div>

                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => {
                        setAddDrawer(true);
                      }}>
                      {t("restaurant.payment_method.add_more_btn")}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* modal for edit payment method  */}

      <Drawer open={addDrawer}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("restaurant.payment_method.add_payment_type")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setAddDrawer(false);
                formAddPaymentType.resetForm();
              }}>
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <form onSubmit={formAddPaymentType.handleSubmit}>
            <div className="mb-3">
              <label className="form-label" htmlFor="payment_type">
                {" "}
                {t("restaurant.payment_method.payment_type_label")}
              </label>
              <input type="text" id="payment_type" className="form-control" placeholder={t("restaurant.payment_method.payment_type_placeholder")} name="payment_type" value={formAddPaymentType?.values?.payment_type} onChange={formAddPaymentType.handleChange} onBlur={formAddPaymentType.handleBlur} />
              <CustomError name="payment_type" form={formAddPaymentType} className="text-danger" />
            </div>

            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                {t("restaurant.button.btn_submit")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* modal for edit payment method   */}

      <Drawer open={editDrawer}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("restaurant.payment_method.edit_payment_type")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setEditDrawer(false);
                formEditPaymentType.resetForm();
              }}>
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <form onSubmit={formEditPaymentType.handleSubmit}>
            <div className="mb-3">
              <label className="form-label" htmlFor="payment_type">
                {" "}
                {t("restaurant.payment_method.payment_type_label")}
              </label>
              <input
                type="text"
                id="payment_type"
                className="form-control"
                placeholder={t("restaurant.payment_method.payment_type_placeholder")}
                name="payment_type"
                value={formEditPaymentType?.values?.payment_type}
                onChange={formEditPaymentType.handleChange}
                onBlur={formEditPaymentType.handleBlur}
              />
              <CustomError name="payment_type" form={formEditPaymentType} className="text-danger" />
            </div>

            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                {t("restaurant.button.btn_update")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>
    </main>
  );
}

export default PaymentMethod
